import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';

const ModuleCard = ({ moduleItem, onClick }) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        p: 3,
        cursor: 'pointer',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.2s',
        '&:hover': { transform: 'translateY(-4px)', boxShadow: 4 },
      }}
    >
      <Box sx={{ width: 44, height: 44, bgcolor: '#22419e', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        <ArticleIcon sx={{ color: 'white' }} />
      </Box>
      <Typography variant="h6" fontWeight="600" mb={1}>
        {moduleItem.moduleName}
      </Typography>
      <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: 'text.secondary' }}>
        <Typography variant="body2">{moduleItem.articleCount || 0} Knowledge Base</Typography>
      </Box>
    </Card>
  );
};

export default ModuleCard;
